import analyticsService from '../shared-services/analytics-service';
import {doesUseMiles} from './settings';
// stored globally to survive scope destruction, as happens between all menu-item switches.
if (!window.mmcUtils.MAN) {
  const MAN = {
    // master map content lists:
    // ANY place that adds content to a map, MUST report its content here.
    // Future: implement all map content additions through wrapper utils, instead of just requiring a second line of code there.
    allMapContent: [],
    markerCluster: undefined, // Markerclusters have their own special removal method that is different than others.
    routePolyline: undefined, // hacky fix until we implement adding all content via wrappers for a problem child.

    globalMap: undefined, // will be defined by getMap() when it gets called within main-service.js.
    getMap(customMapOptions) {
      return this.globalMap || this.initGlobalMap(customMapOptions);
    },
    initGlobalMap(customMapOptions) {
      const mapNode = document.getElementById('map');
      if (!mapNode) {
        return;
      }

      // track the map init for gmaps API usage
      window.mmcUtils.tk('YBZg2ZK6pL');
      Object.assign(mapOptions, customMapOptions);

      // init the map
      const globalMap = new google.maps.Map(
        mapNode,
        mapOptions,
      );
      this.addAllEventListeners(globalMap);
      this.globalMap = globalMap;
      return globalMap;
    },
    onMapViewChange(globalMap, forceReload = false) {
      const bounds = globalMap.getBounds();
      const {MappingService} = window.DataModel;
      const {meterToMile, radiusFilterMultiplier, onChangeMapView, coveredMapRadiusFilter, previousCenter, previousRadius} = MappingService;
      if (bounds && onChangeMapView && ['accountsMapPage', 'contactsMapPage'].includes(this.$route.current.id)) {
        const center = globalMap.getCenter();
        // normalized center is needed because when you drag a map, google can go
        // beyond -180..180 range. Normalizing returns coordinates into that range.
        // E.g. lng 0, 110, 220, 330, 440 will be converted into 0, 110, -140, -30, 80
        // Google normalizes coordinates itself when you create a new LatLng object.
        const normalizedCenter = new google.maps.LatLng(center.lat(), center.lng());

        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();
        // meters to miles and divide by 2 to get a radius
        const radiusNoMultiplier = Math.round((google.maps.geometry.spherical.computeDistanceBetween(ne, sw) / ((doesUseMiles() ? meterToMile : 1000.0) * 2)));
        const radius = radiusNoMultiplier * radiusFilterMultiplier;

        let performChangeRadius = !coveredMapRadiusFilter;
        if (previousCenter && google.maps.geometry.spherical.computeDistanceBetween(center, previousCenter) === 0 && previousRadius === radius) {
          performChangeRadius = false;
        } else if (coveredMapRadiusFilter) {
          const coveredCenter = new google.maps.LatLng(coveredMapRadiusFilter.center[1], coveredMapRadiusFilter.center[0]);
          const centerDiff = google.maps.geometry.spherical.computeDistanceBetween(coveredCenter, center) / (doesUseMiles() ? meterToMile : 1000.0);
          if ((centerDiff + radiusNoMultiplier) > coveredMapRadiusFilter.radius) {
            performChangeRadius = true;
          }
        }
        if (performChangeRadius || forceReload) {
          onChangeMapView({radius, center: [normalizedCenter.lng(), normalizedCenter.lat()]});
        }
        window.DataModel.MappingService.previousRadius = radius;
        window.DataModel.MappingService.previousCenter = center;
      }
    },
    // adds all listeners to the map (e.g. map init and after lasso delete/saves)
    addAllEventListeners(globalMap) {
      // set this listener once on init; any permanent listeners should go here.
      const zoomChangedListener = () => {
        analyticsService.clicked(['Map', 'change zoom'], {zoom: globalMap.getZoom()});
        if (window.mmcGlobals.slowScroll) clearInterval(window.mmcGlobals.slowScroll);
        if (MAN.shouldSaveMapPositionChange()) {
          this.onMapViewChange(globalMap);
          window.DataModel.savedMapViewport = {
            ...window.DataModel.savedMapViewport,
            zoom: globalMap.getZoom(),
          };
          MAN.saveZoom(globalMap);
        }
        window.DataModel.previousZoom = globalMap.getZoom();
      };

      const centerChangedListener = () => {
        if (MAN.shouldSaveMapPositionChange()) {
          this.onMapViewChange(globalMap);
          window.DataModel.savedMapViewport = {
            ...window.DataModel.savedMapViewport,
            center: globalMap.getCenter().toJSON(),
          };
          MAN.saveCenter(globalMap);
        }
      };

      const idleListener = function idleListener() {
        if (window.mmcGlobals.slowScroll) clearInterval(window.mmcGlobals.slowScroll);
        MAN.saveMapPositionChangesFlag = true;
      };

      google.maps.event.addListener(
        globalMap,
        'center_changed',
        centerChangedListener,
      );
      google.maps.event.addListener(
        globalMap,
        'zoom_changed',
        zoomChangedListener,
      );
      google.maps.event.addListener(globalMap, 'idle', idleListener);
    },

    initZoomControl(map) {
      document.querySelector('.zoom-control-in').onclick = function () {
        map.setZoom(map.getZoom() + 1);
      };
      document.querySelector('.zoom-control-out').onclick = function () {
        map.setZoom(map.getZoom() - 1);
      };
      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(
        document.querySelector('.zoom-control'),
      );
    },

    initMapTypeControl(map) {
      const mapTypeControlDiv = document.querySelector('.maptype-control');
      document.querySelector('.maptype-control-map').onclick = function () {
        mapTypeControlDiv.classList.add('maptype-control-is-map');
        mapTypeControlDiv.classList.remove('maptype-control-is-satellite');
        map.setMapTypeId('roadmap');
      };
      document.querySelector(
        '.maptype-control-satellite',
      ).onclick = function () {
        mapTypeControlDiv.classList.remove('maptype-control-is-map');
        mapTypeControlDiv.classList.add('maptype-control-is-satellite');
        map.setMapTypeId('hybrid');
      };
      map.controls[google.maps.ControlPosition.LEFT_TOP].push(
        mapTypeControlDiv,
      );
    },

    initFullscreenControl(map) {
      const elementToSendFullscreen = map.getDiv().firstChild;
      const fullscreenControl = document.querySelector('.fullscreen-control');
      map.controls[google.maps.ControlPosition.RIGHT_TOP].push(
        fullscreenControl,
      );


      fullscreenControl.onclick = function () {
        if (this.isFullscreen(elementToSendFullscreen)) {
          this.exitFullscreen();
        } else {
          this.requestFullscreen(elementToSendFullscreen);
        }
      };

      // eslint-disable-next-line no-multi-assign
      document.onwebkitfullscreenchange = document.onmsfullscreenchange = document.onmozfullscreenchange = document.onfullscreenchange = function () {
        if (this.isFullscreen(elementToSendFullscreen)) {
          fullscreenControl.classList.add('is-fullscreen');
        } else {
          fullscreenControl.classList.remove('is-fullscreen');
        }
      };
    },

    isFullscreen(element) {
      return (
        (document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement) === element
      );
    },

    requestFullscreen(element) {
      analyticsService.clicked(['Map', 'Enter full screen']);
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullScreen) {
        element.msRequestFullScreen();
      }
    },

    exitFullscreen() {
      analyticsService.clicked(['Map', 'Exit full screen']);
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msCancelFullScreen) {
        document.msCancelFullScreen();
      }
    },

    // completely wipes map of all content, for map recycling, EXCEPT for traffic layer.
    nukeMapContent() {
      console.warn('NUKING');
      this.allMapContent.forEach(this.removeContent);
      this.allMapContent = [];

      // google.maps.event.clearInstanceListeners(this.globalMap);
      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
      }
    },

    // removes nearby map added from nearby page
    removeNearbyAndFindCustomersCircles() {
      // nearby circle already existed --> remove & delete
      if (window.DataModel.circle) {
        window.DataModel.circle.setMap(null);
        window.DataModel.circle = null;
      }
      if (window.DataModel.findCustomersCircle) {
        window.DataModel.findCustomersCircle.setMap(null);
        window.DataModel.findCustomersCircle = null;
      }
    },

    // clears an individual list. helper method for nuke method.
    removeContent(content /* , index, allMapContent */) {
      try {
        content.setMap(null);
      } catch (e) {
        console.error('error while trying to clear something:', e, content);
      }
    },

    showingTraffic: false,
    newTrafficLayer: () => new google.maps.TrafficLayer(),
    currentTrafficLayer: undefined,
    trafficToggle(force) {
      const trafficLayer = this.currentTrafficLayer || this.newTrafficLayer();
      if (force || this.showingTraffic) {
        trafficLayer.setMap(this.getMap());
        this.showingTraffic = true;
      } else {
        trafficLayer.setMap(null);
        this.currentTrafficLayer = undefined;
        this.showingTraffic = false;
      }
    },

    makeCustomBounds(...pins) {
      const bounds = new google.maps.LatLngBounds();
      pins.forEach(pin => {
        if (pin.latitude && pin.longitude) {
          const pinLatlng = new google.maps.LatLng(pin.latitude, pin.longitude);
          bounds.extend(pinLatlng);
        }
      });
      return bounds;
    },

    offsetMap(offsetX, offsetY) {
      const map = this.getMap();
      if (!map) {
        return;
      }

      // convert map center from latlng into a screen coordinates in pixels
      const overlay = new google.maps.OverlayView();
      overlay.draw = () => undefined;
      overlay.setMap(map);
      const projection = overlay.getProjection();
      const pixelsCenter = projection.fromLatLngToDivPixel(map.getCenter());

      // offset pixelsCenter
      pixelsCenter.x += offsetX;
      pixelsCenter.y += offsetY;

      // convert pixelsCenter to latlng back again and set it as a new map center
      this.panTo(projection.fromDivPixelToLatLng(pixelsCenter), true);
    },

    //
    // Saving zoom changes
    //

    // WRAPPERS
    panTo(proposedCenter, force) {
      this.eitherUseSavedOrCalledMapSettings('panTo', proposedCenter, force);
    },
    setCenter(proposedCenter) {
      this.eitherUseSavedOrCalledMapSettings('setCenter', proposedCenter);
    },
    setZoom(proposedZoom) {
      // if we set zoom through this function, we don't want to save it.
      // so we set the save flag to false, which the listener looks at
      // when a save event occurs. After the listener fires, it puts it
      // back to true.
      this.eitherUseSavedOrCalledMapSettings('setZoom', proposedZoom);
    },
    fitBounds(proposedBounds, force) {
      // same idea as this.setZoom; see there for comments.
      this.eitherUseSavedOrCalledMapSettings(
        'fitBounds',
        proposedBounds,
        force,
      );
    },
    setOptions(proposedOptions) {
      // same idea as this.setZoom; see there for comments.
      this.eitherUseSavedOrCalledMapSettings('setOptions', proposedOptions);
    },

    eitherUseSavedOrCalledMapSettings(method, arg, force) {
      const ignoreSaved = !this.viewingMainMapPage() || force;

      if (ignoreSaved || !this.hasDoneFirstCenter) {
        console.log('moving map and...');
        this.saveMapPositionChangesFlag = false;
        this.globalMap[method](arg);
        if (!this.hasDoneFirstCenter) {
          setTimeout(() => {
            MAN.hasDoneFirstCenter = true;
            MAN.saveCenter(MAN.globalMap, true);
            MAN.saveZoom(MAN.globalMap, true);
            MAN.recycleMap();
          }, 200); // timeout is because zoom change save is async, iirc.
        } else {
          console.log("won't save what I'm updating map to.");
        }
      } else {
        console.log('ignoring real request, going to saved map settings');
        this.goToSavedZoomAndCenter();
      }
    },

    saveCenter(map, force = false) {
      if (this.saveMapPositionChangesFlag || force) {
        this.savedOptions.center = map.getCenter().toJSON();
      }
    },
    saveZoom(map, force = false) {
      if (MAN.shouldSaveMapPositionChange() || force) {
        this.savedOptions.zoom = map.getZoom();
      }
    },

    hasSavedZoomOrCenter() {
      return !!Object.keys(window.DataModel.savedMapViewport || {}).length;
    },

    goToSavedZoomAndCenter(map) {
      map = map || this.globalMap;
      if (!map) {
        return;
      }
      this.saveMapPositionChangesFlag = false;
      map.setOptions(this.savedOptions);
      map.setOptions(window.DataModel.savedMapViewport);
      setTimeout(() => {
        window.mmcUtils.MAN.saveMapPositionChangesFlag = true;
      }, 1000);
    },

    // FLAGS
    saveMapPositionChangesFlag: false, // set to false before programatic zoom changes, then back to true for user. True on 'idle' event.
    hasDoneFirstCenter: false, // set to true after first center.

    userSaveMapPages: [
      'mapPage',
      'groupsPage',
      'accountsMapPage',
      'contactsMapPage',
      'dealsMapPage',
      'accountsGroupsMapPage',
      'dealsGroupsMapPage',
      'contactsGroupsMapPage',
      'territoriesMapPage',
      'accountsRoutingMapPage',
      'contactsRoutingMapPage',
    ], // pages we save user zoom adjustments from.

    savedOptions: {
      scrollwheel: null, // default, adjusted elsewhere when we grab user settings.
      zoom: 4,
      center: {lat: 40.689247, lng: -74.044502}, // default position until received elsewhere
      minZoom: 2,
      maxZoom: 23,
      disableDefaultUI: false,
      zoomControl: true,
    },
    userPosition: null, // set to a latlng literal when navigator reports.
    lastResortPosition: {
      // for when no other position is available. NYC coordinates, specifically Statue of Liberty
      lat: 40.689247,
      lng: -74.044502,
    },

    shouldSaveMapPositionChange() {
      return (
        window.mmcUtils.MAN.saveMapPositionChangesFlag &&
        this.viewingMainMapPage()
      );
    },

    viewingMainMapPage() {
      const nowAt = this.$route.current.id;
      return this.userSaveMapPages.includes(nowAt);
    },

    //
    // Misc map stuff
    //
    promptForPosition(callback) {
      console.log('promptForPosition(callback)', callback);
      return new Promise(((resolve) => {
        swal({
          type: 'question',
          input: 'text',
          title: "We can't find you...",
          text:
            'You need to enable location sharing with us (and refresh the page) or just give us your location below:',
          showCancelButton: false,
          confirmButtonText: 'Submit',
          animation: 'true',
          inputPlaceholder: 'e.g., Raleigh, NC, 27606',
          showLoaderOnConfirm: true,
          inputValidator: null, // could add some validation here, but google probably has it covered.
          allowOutsideClick: true,
          preConfirm() {
            return new Promise(((resolve2) => {
              resolve2();
            }));
          },
        })
          .then((address) => {
            window.mmcUtils.tk('5HRxYVW6Hq');
            new google.maps.Geocoder().geocode(
              {address},
              (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                  swal({
                    type: 'success',
                    title: 'Got it!',
                    text: `Your location is: ${results[0].formatted_address}`,
                  });
                  MAN.userPosition = {
                    lat: results[0].geometry.location.lat(),
                    lng: results[0].geometry.location.lng(),
                  };

                  // generally, functions calling this function should recall themselves with their own arguments again,
                  // the difference being that they can now assume the MAN.userPosition is set.
                  callback();
                  resolve();
                } else {
                  swal(
                    `error: ${status}`,
                    "We weren't able to understand that location. Maybe try again? It can be an address with city, state, and postal code.",
                  );
                  window.location.href = '#/';
                }
              },
            );
          })
          .catch(() => {
            swal(
              'Uh-Oh',
              "That didn't quite work. Try refreshing and typing it in a more clear way or contact customer support. Sorry about that!",
              'error',
            );
          });
      }));
    },

    addedContentMessage(...args) {
      console.log('added content msg:', ...args);
    },

    triggerResize() {
      const map = this.getMap();
      if (!map) {
        return;
      }
      google.maps.event.trigger(this.globalMap, 'resize');
      console.log('triggered resize');
    },

    recycleMap() {
      console.log('recycleMap()');
      const map = this.getMap();
      if (!map) {
        return;
      }
      const mapNode = map.getDiv();
      $('#map').replaceWith(mapNode);
      MAN.triggerResize();
      this.globalMap.setOptions(this.savedOptions);
      this.triggerResize();
    },
  };
  window.mmcUtils.MAN = MAN;
}

//
// style and customization options for initialization,
// have nothing to do with 'savedOptions', for instance.
//
const mapOptions = {
  disableDefaultUI: false,
  cameraControl: false,
  mapTypeControl: true,
  mapTypeControlOptions: {
    style: google.maps.MapTypeControlStyle.VERTICAL_BAR,
    position: google.maps.ControlPosition.TOP_RIGHT,
  },
  zoomControlOptions: {
    position: google.maps.ControlPosition.LEFT_BOTTOM,
  },
  streetViewControlOptions: {
    position: google.maps.ControlPosition.LEFT_BOTTOM,
  },
};
